import {getRequest, postRequest} from "../libs/AxiosService.util";

export async function fetchWhatsappConversations(params= {}) {
    return await getRequest('whatsapp/conversations', params);
}

export async function fetchWhatsappMessages(conversationId, params = {}) {
    return await getRequest(`whatsapp/conversations/${conversationId}/messages`, params);
}

export async function serviceSendMessage(params) {
    return await postRequest('whatsapp/send/message', params);
}
export async function serviceInitiateCoversation(params) {
    return await postRequest('whatsapp/initiate/conversation', params);
}
